
export default function column($compile, FieldViewConfiguration) {

    function linkFn(scope, element) {
        // debugger;

        if (typeof scope.field === 'undefined')
            return;

        scope.value = function () {
            if (typeof scope.entry === 'undefined') {
                return '';
            }
            return scope.entry[scope.field.name()];
        };

        let type = scope.field.type();
        element.append(FieldViewConfiguration[type].getReadWidget());
        $compile(element.contents())(scope);
    }

    return {
        restrict: 'E',
        scope: {
            field: '<',
            entry: '<',
            entity: '<',
            datastore: '&'
        },
        link: linkFn
    };
}

column.$inject = ['$compile', 'FieldViewConfiguration'];



// WEBPACK FOOTER //
// ./app/components/common/crud/column/column.js